// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-list-cardList-9fa89{display:flex;flex-wrap:wrap;justify-content:space-between;margin:0 .3rem .42rem}.card-list-cardList-9fa89 .card-list-cardWrap-d0d7b{background:#fff;border-radius:.27rem;margin:.12rem 0;overflow:hidden;padding-bottom:.36rem;width:5.79rem}.card-list-cardList-9fa89 .card-list-passMkd-5caa7{height:10rem;width:10rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardList": "card-list-cardList-9fa89",
	"cardWrap": "card-list-cardWrap-d0d7b",
	"passMkd": "card-list-passMkd-5caa7"
};
export default ___CSS_LOADER_EXPORT___;
